const rolesDescription = (role) => {
    let description = "";
    switch (role) {
        case "ADMIN":
            description = "As a System Administrator, you are responsible for overseeing the configuration and operational integrity of MatWatch. You manage user accounts, roles, categories, regions, and other system settings to ensure proper access control and alignment with organizational structures.";
            break;
        case "REGULATORY":
            description="As a Regulatory member your role is to review and manage material exit requests in MatWatch, ensuring compliance with regional and global requirements. You coordinate approvals, provide regulatory input, and align timelines across markets to support a smooth and compliant exit process.\n"
            break;
        case "R&D":
            description="As a part of the R&D teams , you perform impact analysis across regions and categories, then create and submit exit plans in MatWatch. You support early planning, cross-functional alignment, and informed decision-making for material changes."
            break;
        case "APPROVER":
            description="As an Approver, you monitor exit requests and plans within MatWatch. You are responsible for reviewing and approving exit plans when requested, and responding to escalated exit requests to maintain compliance and facilitate smooth coordination across teams."
            break;
        case "RD_MANAGER":
            description="As an R&D Manager, you perform all R&D functions including impact analysis, exit plan creation, and responding to exit requests. Additionally, you manage R&D team members and handle escalated requests from your team."
            break;
    }
    return description;
}
export {rolesDescription};